interface IGeography {
    guid: string;
    name: string;

} 
export interface Country {
    guid: string;
    name: string;
}

export interface City {
    guid: string;
    name: string;
    country: Country;
}

export interface EventLocation {
    guid: string;
    name: string;
    city?: City;
    position: google.maps.LatLngLiteral;    
}

export interface EventLocationSelectorOptions {
    selector: string;
    disableAutoSelect: boolean;
    displayRadius: boolean;
    imagesBaseUrl: string;
    backgroundImageName: string;
    defaultBackgroundImageUrl: string;
    countriesUrl: string;
    citiesUrl: string;  
    locationsUrl: string;  
}

export interface IGeographyProvider {    
    getEventLocations(cityGuid: string): Promise<EventLocation[]>;
}

export class EventLocationSelector implements IGeographyProvider{

    private options: EventLocationSelectorOptions;
    private _submitTimeout: NodeJS.Timeout;
    
    private _entries: EventLocation[];    

    private static _instance: EventLocationSelector;

    public static get Instance(): EventLocationSelector {
        return this._instance;
    };
    
    constructor(options: EventLocationSelectorOptions) {

        EventLocationSelector._instance = this;
        this.options = options;
        const _ = this;

        // preloadBackground default background!
        (new Image()).src = options.defaultBackgroundImageUrl;

        $(async function () {
            await _.initAsync(options);
        });

        function loadEventLocations() {
            const cached = window.sessionStorage.getItem('eventLocations');
            if (cached) {
                _._entries = JSON.parse(cached);
            } else {
                $.post({ url: options.locationsUrl, async: false }).then(result => {
                    _._entries = result;
                    window.sessionStorage.setItem('eventLocations', JSON.stringify(result));
                }).catch(r => {
                    throw r;
                });
            }
        }
        loadEventLocations();
    }

    //#region IGeographyProvider
    public getEventLocations(cityGuid: string): Promise<EventLocation[]> {
        return new Promise((resolve, reject) => {
            resolve(this._entries.filter(c => c.city?.guid === cityGuid));
        });
    }
    //#endregion

    //#region properties 
    public get countryGuid() {
        return $("#CountryGuid").val() as string;
    }

    public get cityGuid() {
        return $("#CityGuid").val() as string;
    }
    public get eventLocationGuid() {
        return $("#EventLocationGuid").val() as string;
    }

    public get radius(): number {
        return Number( $("#Radius").val());
    }

    public get selectedEventLocation(): EventLocation | null {        
        return this._entries.find(e => e.guid == this.eventLocationGuid);         
    }
       
    public get eventLocations(): EventLocation[] {
        return this._entries??[];        
    }

    public static get eventLocations(): EventLocation[] {

        return this.Instance.eventLocations;
    }
    //#endregion

    
    //#region initialize
    private async initAsync(options: EventLocationSelectorOptions ): Promise<void> {
        const _ = this;
         

        return new Promise((resolve, reject) => {                      

            $('#distanceValue').text($('#Radius').val() as string);

            $("#CountryGuid").on('change', function () {
                const selectedItem = $(this).val();
                const dropdown = $("#CityGuid");
                const progress = $("#cities-loading-progress");
                progress.show();
                $.ajax({
                    cache: false,
                    type: "GET",
                    url: options.citiesUrl,
                    data: { "countryGuid": selectedItem },
                    success: function (data) {
                        dropdown.html('');

                        if (options.disableAutoSelect) {
                            dropdown.append($("<option></option>").html('Select city'));
                        }

                        $.each(data, function (id, option) {
                            dropdown.append($('<option></option>').val(option.guid).html(option.name));
                        });
                        progress.hide();
                        setTimeout(() => {
                            $("#CityGuid").trigger("change");
                        }, 100);

                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        alert('Failed to retrieve states.');
                        progress.hide();
                    }
                });
            });

            $("#CityGuid").on('change', function () {

                // change picture !!

                const selectedItem = $(this).val();

                const name = $(this).find(`[value=${selectedItem}]`).text();


                const dropdown = $("#EventLocationGuid");
                const progress = $("#eventlocations-loading-progress");
                progress.show();
                $.ajax({
                    cache: false,
                    type: "GET",
                    url: options.locationsUrl,// "@(Url.Action("SearchEventLocations", "Geography"))",
                    data: { "cityGuid": selectedItem },
                    success: function (data) {
                        dropdown.html('');

                        if (options.disableAutoSelect) {
                            dropdown.append($("<option></option>").html('Select location'));
                        }

                        $.each(data, function (id, option) {
                            dropdown.append($('<option></option>').val(option.guid).html(option.name));
                        });
                        progress.hide();
                        setTimeout(() => {
                            $("#EventLocationGuid").trigger("change");
                        }, 100);

                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        alert('Failed to retrieve states.');
                        progress.hide();
                    }
                });

            });

            $('#Radius').on('input change', function () {
                $('#distanceValue').text($(this).val() as string);
                $('input[name=Radius]').val($(this).val());
            });


            $("#EventLocationGuid")
                .on('change', _.synchronize)
                .on('change', _.ajaxSubmit)
                .on('change', () => _.pushUrlState()).trigger('change');

            
            if (options.displayRadius) {
                $("#Radius").on('change', _.synchronize)
                    .on('change', _.ajaxSubmit)
                    .on('change', () => _.pushUrlState())
                    .trigger('change');
            }
            
            resolve();
        });
        
    }

    private synchronize() {
        var name = $(this).attr('name');
        $(`input[name=${name}]`).val($(this).val());
    }
    private pushUrlState() {

        this.preloadBackground()
            .then(() => {
                $('body').attr('data-bg-city', this.cityGuid);
            })
            .catch(e => {
                $('body').removeAttr('data-bg-city');
            });

        let params = new URLSearchParams(window.location.search);

        params.set("EventLocationGuid", this.eventLocationGuid);

        if (this.options.displayRadius) {
            params.set("Radius", this.radius.toString());
        }

        window.history.pushState('object or string', 'Title', "?" + params.toString());    

    }
    

    private preloadBackground(): Promise<void> {

        return new Promise((resolve, reject) => {

            var city = this.selectedEventLocation.city.name; 
            var url = `${this.options.imagesBaseUrl}/${city}/${this.options.backgroundImageName}`;

            var image = new Image();
            image.onload = ()=>resolve();
            image.onerror = reject;
            image.src = url;
        });
    }    

    private ajaxSubmit() {
                
        clearTimeout(this._submitTimeout);
        this._submitTimeout = setTimeout(() => {

            $(this).closest('form').trigger('submit');
        }, 100);
    }
    //#endregion

}


window.EventLocationSelector = EventLocationSelector;
